import React, { Component } from 'react'
import Style from './AddOrganization.module.css'
import { setError, addEnrolledEmailDomain, updateEnrolledEmailDomain, unSetStatusCode } from '../store/entities/customers'
import { connect } from 'react-redux'
import ConfirmPopup from './common/popover/confirmPopup'
import BackIcon from '../assets/backButton.svg'

class AddEditEmailDomain extends Component {
    constructor() {
        super();
        this.state = { domain: '', isEdit: false, domainId: null }
    }

    componentDidMount() {
        const locState = this.props.location && this.props.location.state
        if (locState && locState.domain) {
            this.setState({ domain: locState.domain, isEdit: true, domainId: locState.domainId || locState.id })
        }
    }

    handleChange = (e) => {
        this.setState({ domain: e.target.value })
    }

    handleClick = () => {
        this.props.history.push({ pathname: `/customers/${this.props.selectedCustomer.id}/settings`, state: { tab: 'Email Domain Management' } })
    }

    validateDomain = (domain) => {
        if (!domain) return 'Domain is required.'
        if (domain.length > 253) return 'Domain must be 253 characters or fewer.'
        if (domain.indexOf(' ') !== -1) return 'Domain must not contain spaces.'
        const label = "[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?"
        const regex = new RegExp(`^(?:${label})(?:\.(?:${label}))+${'$'}`)
        if (!regex.test(domain)) return 'Invalid domain format.'
        return ''
    }

    handleSubmit = () => {
        const { domain, isEdit, domainId } = this.state
        const { setError, addEnrolledEmailDomain, updateEnrolledEmailDomain, selectedCustomer } = this.props
        const trimmed = domain.trim().toLowerCase()
        const err = this.validateDomain(trimmed)
        if (err) {
            setError(err)
            return
        }
        if (!selectedCustomer) {
            setError('No customer selected')
            return
        }
        if (isEdit) {
            updateEnrolledEmailDomain(selectedCustomer.id, { domainId: domainId, domain: trimmed })
        } else {
            addEnrolledEmailDomain(selectedCustomer.id, { domain: trimmed })
        }
    }

    handleConfirmClose = () => {
        if (this.props.statusCode === 200) {
            this.props.history.push({ pathname: `/customers/${this.props.selectedCustomer.id}/settings`, state: { tab: 'Email Domain Management' } })
        }
        this.props.unSetStatusCode()
    }

    render() {
        const { isEdit } = this.state
        return (
            <div className={'px-5 mt-4'}>
                <div className={`${Style.headerBg} px-5 d-flex align-items-center justify-content-between`}>
                    <div onClick={this.handleClick} style={{ cursor: 'pointer' }}>
                        <img style={{ height: '1.5vw' }} src={BackIcon} alt={'back-icon'} />
                        Return to Enrolled Email Domains
                    </div>
                </div>
                <div className={`${Style.detailsContainer} w-50 mt-4 py-5 px-5`}>
                    <div className={`d-flex flex-column`}>
                        <input name='domain' value={this.state.domain} placeholder={'example.com'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />
                    </div>
                    <div className={'mt-4'}>
                        <button onClick={this.handleSubmit} className={`${Style.submitButton} px-4 focus-none`}>{isEdit ? 'Update Domain' : 'Add Domain'}</button>
                        <button onClick={this.handleClick} className={`${Style.cancelButton} px-4 ml-2 focus-none`}>Cancel</button>
                    </div>
                </div>
                {this.props.statusCode && (
                    <ConfirmPopup
                        details={{
                            icon: '',
                            type: this.props.statusCode === 200 ? 'success' : 'error',
                            title: this.props.statusCode === 200 ? (isEdit ? 'Domain updated' : 'Domain added') : 'Could not complete operation',
                            description: this.props.userMsg,
                            buttons: 'O',
                        }}
                        onCloseClick={this.handleConfirmClose}
                    />
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    selectedCustomer: state.entities.customers.selected,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
})

const mapDispatchToProps = (dispatch) => ({
    addEnrolledEmailDomain: (customerId, body) => dispatch(addEnrolledEmailDomain(customerId, body)),
    updateEnrolledEmailDomain: (customerId, body) => dispatch(updateEnrolledEmailDomain(customerId, body)),
    setError: (error) => dispatch(setError(error)),
    unSetStatusCode: () => dispatch(unSetStatusCode())
})

export default connect(mapStateToProps, mapDispatchToProps)(AddEditEmailDomain)
